function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Divider, Grid, CardActions, CardMedia, CardActionArea } from '@material-ui/core';
var styles = {
  card: {
    minWidth: 275,
    margin: 20
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  }
};

function FieldSet(props) {
  var classes = props.classes,
      title = props.title,
      list = props.list,
      children = props.children,
      color = props.color,
      actions = props.actions,
      media = props.media,
      mediaTitle = props.mediaTitle,
      mediaAction = props.mediaAction;

  var content = function content() {
    return React.createElement(Fragment, null, media && React.createElement(CardMedia, {
      style: {
        height: 200
      },
      image: media,
      title: mediaTitle
    }), React.createElement(CardContent, null, React.createElement(Typography, {
      className: classes.title,
      color: "textSecondary",
      gutterBottom: true
    }, title), React.createElement(Divider, null), React.createElement("div", {
      style: {
        margin: 5
      }
    }, list && React.createElement(Grid, {
      container: true,
      direction: "column"
    }, list.map(function (item, idx) {
      return React.createElement(Grid, {
        item: true,
        container: true,
        key: idx
      }, React.createElement(Grid, {
        item: true,
        xs: true
      }, React.createElement(Typography, {
        variant: "subtitle2"
      }, item.label, " :")), React.createElement(Grid, {
        item: true,
        xs: true
      }, React.createElement(Typography, {
        variant: "body2",
        component: "div"
      }, item.value ? item.value : '-')));
    })), children)));
  };

  return React.createElement(Card, _extends({
    className: classes.card
  }, color ? {
    style: {
      backgroundColor: color
    }
  } : {}), mediaAction ? React.createElement(CardActionArea, {
    onClick: mediaAction
  }, content()) : content(), actions && React.createElement(CardActions, null, actions));
}

FieldSet.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  list: PropTypes.array
};
export default withStyles(styles)(FieldSet);